/**
 * @generated SignedSource<<692244adc80e1f5ba17afaf7b37bfa7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AsanaIntegrationWorkspaceQuery$variables = {};
export type AsanaIntegrationWorkspaceQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly asana: {
        readonly workspaces: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }> | null;
      } | null;
    };
  };
};
export type AsanaIntegrationWorkspaceQuery = {
  response: AsanaIntegrationWorkspaceQuery$data;
  variables: AsanaIntegrationWorkspaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "AsanaWorkspaceNode",
  "kind": "LinkedField",
  "name": "workspaces",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationWorkspaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AsanaIntegrationWorkspaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8d4b67908f2a14fddd6219b1e958dc7",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationWorkspaceQuery",
    "operationKind": "query",
    "text": "query AsanaIntegrationWorkspaceQuery {\n  viewer {\n    integrations {\n      asana {\n        workspaces {\n          id\n          externalId\n          name\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e5f4f1cb6a025450789092d65a5a139";

export default node;
